import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import SKUSelector from "components/source/reservations/sku-selector";

class SizeSelectors extends React.Component {
  static propTypes = {
    sizeNames: PropTypes.object.isRequired, // let's see if we can live with this, not a custom validator
    skus: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    // onAnimatedInputChange is used as the onChange func
    // for new animated input fields. The function takes
    // four arguments - value, isValid, name, inputObj
    onAnimatedInputChange: PropTypes.func,
    primarySkuValue: PropTypes.string,
    backupSkuValue: PropTypes.string,
    offerBackupSize: PropTypes.bool,
    primarySkuError: PropTypes.string,
    backupSkuError: PropTypes.string,
    inline: PropTypes.bool,
    isRental: PropTypes.bool,
    isBulk: PropTypes.bool,
    isClearance: PropTypes.bool,
    placeholderText: PropTypes.string,
  };

  static defaultProps = {
    offerBackupSize: false,
    primarySkuError: "",
    backupSkuError: "",
    primarySkuValue: "",
    backupSkuValue: "",
    placeholderText: "",
  };

  selectors = () => {
    var selectors = [
      {
        error: this.props.primarySkuError,
        id: "product-primary-size",
        label: "Size",
        name: "reservation[primarySku][id]",
        wrapperClass: "rentable-form-fields__size-wrapper rentable-form-fields__size-wrapper--primary-size",
        value: this.props.primarySkuValue,
        placeholder: this.props.placeholderText,
      },
    ];

    if (this.props.offerBackupSize) {
      // We want the error to always be a string. If there's an error that's a bool (and true), let's
      // render the regular label text in red
      const backupError = this.props.backupSkuError === true ? "Free Backup Size" : this.props.backupSkuError;

      selectors.push({
        error: backupError,
        id: "product-backup-size",
        label: "Free Backup Size",
        name: "reservation[backupSku][id]",
        wrapperClass: "rentable-form-fields__size-wrapper rentable-form-fields__size-wrapper--backup-size",
        value: this.props.backupSkuValue,
        placeholder: "No Thanks",
        isBackup: true,
      });
    }

    return selectors;
  };

  render() {
    return (
      <div className="size-selectors">
        {_.map(
          this.selectors(),
          function (s, index) {
            return (
              <SKUSelector
                key={index}
                error={s.error}
                id={s.id}
                label={s.label}
                name={s.name}
                placeholder={s.placeholder}
                sizeNames={this.props.sizeNames}
                skus={this.props.skus}
                onBlur={this.registerExperimentInteraction}
                onChange={this.props.onChange}
                onAnimatedInputChange={this.props.onAnimatedInputChange}
                value={s.value}
                wrapperClass={s.wrapperClass}
                inline={this.props.inline}
                isBackup={s.isBackup}
                isRental={this.props.isRental}
                isBulk={this.props.isBulk}
                isClearance={this.props.isClearance}
              />
            );
          },
          this
        )}
      </div>
    );
  }
}

export default SizeSelectors;
